import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import upLoad from '@/assets/img/upload_photo3.jpg';
import {
  required,
  maxLength
} from "vuelidate/lib/validators";

export default {
  name: "noticeCreate",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading
  },

  data() {
    return {
      config : { 
        minDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1)+ '-' + (new Date().getDate() )
      },
      time_config: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
      },
      noticeData: {
        send_to: 0,
        class: [],
        student_id: [],
        teacher_id: [],
        status: null,
      },
      allTea: [],
      allStu: [],
      classArr: [],
      submitted: false,
      studentVali: false,
      campusId: '',
      classIdForStu: null,
      classIdForTea: null,
      disabled: false,
      isLoading:false,
      classZeroValidation: false,
      errors: '',
      classVali: false,
      teacherVali: false,
      classForStu: false,
      classForTea: false,
      classArrForStudent: [],
      classArrForTeacher: [],
      defaultSelectOption:  [{
                              'id': 0,
                              'text': 'All'
                            }],
      teacherZeroValidation: false,
      studentZeroValidation: false,
      images: [],
      upLoad,
      sendDateErr: "",
      sendTimeErr: "",
    };
  },

  validations: {
    noticeData: {
      title: {
        required,
        maxLength: maxLength(500)
      },
      message: {
        required,
        maxLength: maxLength(5000)
      },
      send_date: {
        required
      },
      send_time: {
        required
      },

    }
  },

  methods: {
    changeEvent(val, fieldName) {
      if (fieldName == 'studentVali' && val != null) {
        this.studentVali = false;
      }
      if (fieldName == 'teacherVali' && val != null) {
        this.teacherVali = false;
      }
      if (fieldName == 'classVali' && val != null) {
        this.classVali = false;
      }
    },

    getClass() {
      axios.get('class/getGradeAndClass', { params: { campus_id: this.campusId } } )
      .then(res => {
        if (res.data.length != 0) {
          this.classArr = this.defaultSelectOption.concat(res.data);
          this.classArrForStudent = this.defaultSelectOption.concat(res.data);
          this.classArrForTeacher = this.defaultSelectOption.concat(res.data);
        }
        this.isLoading = false;
      }).catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    getStudent(id) {
      if(id != null || id != '') {
        this.classForStu = false;
      }
      this.allStu = [];
      this.noticeData.student_id = null;
      axios.get('student/getallStudent',{ params: { campus_id: this.campusId, class_id: id } } )
      .then(res => {
        if (res.data.length > 0) {
          this.allStu = this.defaultSelectOption.concat(res.data);
        }
        this.isLoading = false;
      }).catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
      this.noticeData.name = '';
    },

    getTeacher(classId) {
      this.classForTea = false;
      this.allTea = [];
      this.noticeData.teacher_id = null;
      if (!classId || classId === 0) {
          this.allTea = this.defaultSelectOption;
          return;
      }
      axios.get(`/teacher/getTeacherByClass/${classId}`)
      .then(res => {
        if (res.data && res.data.length > 0) {
          this.allTea = this.defaultSelectOption.concat(res.data);
        } else {
          this.allTea = this.defaultSelectOption;
        }
      }).catch(error => {
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    sendToAll() {
      this.noticeData.teacher_id = [];
      this.classIdForStu = null;
      this.noticeData.student_id = [];
    },

    sendToTea() {
      this.noticeData.class = [];
      this.classIdForStu = null;
      this.noticeData.student_id = [];
    },

    sendToStu() {
      this.noticeData.class = [];
      this.noticeData.teacher_id = [];
    },

    create() {
      this.submitted = true;
      const sendDateEl = document.getElementById('sendDate');
      const sendTimeEl = document.getElementById('sendTime');
      if (sendDateEl) sendDateEl.innerHTML = '';
      if (sendTimeEl) sendTimeEl.innerHTML = '';
      this.validation();
      if (this.$v.$invalid || this.classVali == true || this.teacherVali == true || this.studentVali == true || this.classForStu == true) {
        return
      }
      this.insert();
    },

    validation() {
      if (this.noticeData.send_to == 0 && this.noticeData.class.length == 0) {
        this.classVali = true;
      } else this.classVali = false;
      if (this.noticeData.send_to == 1 && this.classIdForTea == null) {
        this.classForTea = true;
      } else this.classForTea = false;
      if (this.noticeData.send_to == 1 && this.noticeData.teacher_id == null && this.classIdForTea != 0) {
        this.teacherVali = true;
      } else this.teacherVali = false;
      if (this.noticeData.send_to == 2 && this.classIdForStu == null) {
        this.classForStu = true;
      } else this.classForStu = false;
      if (this.noticeData.send_to == 2 && this.noticeData.student_id == null && this.classIdForStu != 0) {
        this.studentVali = true;
      } else this.studentVali = false;
    },

    insert() {
      this.isLoading = true;
      this.disabled = true;
      this.noticeData.loginId = this.$store.state.user.id;
      this.noticeData.loginRole = this.$store.state.user.role;
      this.noticeData.campusId = this.$store.state.user.campus_id;
      this.noticeData.classIdForStu = this.classIdForStu;
      this.noticeData.img_paths = this.images;
      if (this.noticeData.send_to == 0 && this.noticeData.class != null) {
        if (this.noticeData.class.includes('0')) {
          if (this.noticeData.class.length > 1) {
            this.classZeroValidation = true;
            this.isLoading = false;
            this.disabled = false;
            return;
          } else {
            this.noticeData.sendType = 0;
            this.noticeData.class = [];
          }
        } else {
            this.noticeData.sendType = 5;
        }
      }
      this.classZeroValidation = false;

      if (this.noticeData.send_to == 1) {
        if (this.classIdForTea == 0 || this.classIdForTea === '0') {
          this.noticeData.sendType = 3;
          this.noticeData.teacher_id = [];
        } else {
            if (this.noticeData.teacher_id == null || this.noticeData.teacher_id.length == 0) {
              this.teacherVali = true;
              this.isLoading = false;
              this.disabled = false;
              return;
            }
            this.noticeData.sendType = 1;
            if (this.noticeData.teacher_id.includes('0')) {
                axios.get(`/teacher/getTeacherByClass/${this.classIdForTea}`)
                    .then(res => {
                        if (res.data && res.data.length > 0) {
                            this.noticeData.teacher_id = res.data.map(t => t.id);
                            this.submitNotice();
                        }
                    });
                return;
            }
        }
      }
      this.teacherZeroValidation = false;

      if (this.noticeData.send_to == 2) {
        if (this.classIdForStu == 0 || this.classIdForStu === '0') {
          this.noticeData.sendType = 4;
          this.noticeData.student_id = [];
        } else if (this.classIdForStu != null) {
          if (!this.noticeData.student_id || this.noticeData.student_id.length == 0) {
            this.studentVali = true;
            this.isLoading = false;
            this.disabled = false;
            return;
          }
          this.noticeData.sendType = 2;

          if (this.noticeData.student_id.includes(0) || this.noticeData.student_id.includes('0')) {
            axios.get(`student/getallStudent`, { params: { campus_id: this.campusId, class_id: this.classIdForStu } })
              .then(res => {
                if (res.data && res.data.length > 0) {
                  this.noticeData.student_id = res.data.map(s => s.id);
                  this.submitNotice();
                }
              });
              return;
          }
        }
      }
      this.studentZeroValidation = false;

      this.submitNotice();
     },

    chooseFiles(id) {
        document.getElementById(id).click();
    },

    onFileChange(e) {
        var selectedFiles = e.target.files;
        if (selectedFiles[0].type.startsWith("image/")) {
            if (selectedFiles.type == "image/gif") {
                this.$notification.error("File not supported!", {
                    timer: 3,
                    position: "bottomCenter",
                });
                return;
            }
            for (let i = 0; i < selectedFiles.length; i++) {
                if (selectedFiles[i].size > CONFIG.IMAGE_MAX_FILE_SIZE) {
                    this.$notification.error(CONFIG.IMAGE_MAX_SIZE_ERROR, {
                        timer: 3,
                        position: "bottomCenter",
                    });
                    continue;
                }
                if (this.images.length > 4) {
                    this.$notification.error("Can only upload a maximum of five images.", {
                        timer: 3,
                        position: "bottomCenter",
                    });
                } else {
                    this.images.push(selectedFiles[i]);
                    for (let i = 0; i < this.images.length; i++) {
                        let reader = new FileReader();
                        reader.addEventListener('load', ((index) => {
                            return () => {
                                let refName = this.images[index].name;
                                if (this.$refs[refName] && this.$refs[refName][0]) {
                                    this.$refs[refName][0].src = reader.result;
                                }
                                this.images[index].data = reader.result;
                            };
                        })(i), false);

                        reader.readAsDataURL(this.images[i]);
                    }
                }
            }
        } else {
            this.$notification.error("File not supported!", {
                timer: 3,
                position: "bottomCenter",
            });
            return null;
        }
    },

    removeImage(i) {
        this.images.splice(i, 1);
    },

    submitNotice() {
      axios.post('notice/create', this.noticeData)
        .then(res => {
        if (res.data.success == true) {
            this.$notification.success("Notice Added Successfully", {
            timer: 3,
            position: "bottomCenter"
            });
            this.$router.push({ name: 'noticeList' });
        } else {
            this.errors = res.data.errors;
            this.disabled = false;
        }
        })
        .catch(responseObj => {
            const errors = responseObj.response?.data?.errors || {};
            this.sendDateErr = errors.send_date ? errors.send_date[0] : "";
            this.sendTimeErr = errors.send_time ? errors.send_time[0] : "";

            if (responseObj.response?.status === 401) {
                this.$store.commit('logout');
                window.location.replace('login');
            }
            this.isLoading = false;
            this.disabled = false;
        });
    }
  },

  mounted() {
    this.campusId = this.$store.state.user.campus_id;
    this.getClass();
  },
};
